<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入标题" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="分类" prop="search_category_uuid">
                <VideoCategory v-model="query.search_category_uuid"></VideoCategory>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('spgl_splb_spfl') || permission('spgl_splb_xz')">
            <el-button v-if="permission('spgl_splb_spfl')" size="mini" type="primary" @click="handleCategory"> 视频分类 </el-button>
            <el-button v-if="permission('spgl_splb_xz')" size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100" />
            <el-table-column label="标题" align="center" prop="name" />
            <el-table-column label="副标题" align="center" prop="sub_name" />
            <el-table-column label="关键词" align="center" prop="keyword" />
            <el-table-column label="分类" align="center" prop="category.name" />
            <el-table-column label="上传时间" align="center" prop="create_time" />
            <el-table-column
                v-if="permission('spgl_splb_ckxq') || permission('spgl_splb_bj') || permission('spgl_splb_sc')"
                label="操作"
                align="center"
                width="180"
            >
                <template slot-scope="{ row }">
                    <el-button v-if="permission('spgl_splb_ckxq')" size="mini" type="text" @click="handleDetail(row)"> 查看详情 </el-button>
                    <el-button v-if="permission('spgl_splb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                    <el-button v-if="permission('spgl_splb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/video/list";
import listMixin from "@/mixins/list";
import VideoCategory from "@/components/VideoCategory";

export default {
    components: { VideoCategory },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                search_category_uuid: "",
            },
            module: "视频",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleCategory() {
            this.$router.push({ path: "/video/category" });
        },
        handleAdd() {
            this.$router.push({ path: "/video/list/form" });
        },
        handleDetail(row) {
            this.$router.push({ path: "/video/list/detail", query: { cuuid: row.cuuid } });
        },
        handleEdit(row) {
            this.$router.push({ path: "/video/list/form", query: { cuuid: row.cuuid } });
        },
    },
};
</script>
